import { Factory } from "@/data/dao/Factory";
import { AuthenticationDao } from "@/data/dao/service/AuthenticationDao";

import { logError } from "@/shared/logging/errors";

import { LocationSwitch } from "@/portal/ui/RestaurantSwitch";

export class AccountPanel {
    private $element: JQuery;

    constructor($element: JQuery) {
        this.$element = $element;
        this.$element.find("#logoutbtn").click((e) => {
            e.preventDefault();

            Factory.getInstance<AuthenticationDao>(AuthenticationDao)
                .signOut({ keepAllocation: true })
                .then(() => {
                    LocationSwitch.releaseCache();
                    location.href = "/login";
                })
                .catch((ex) => {
                    logError(ex);
                    location.href = "/login";
                });
        });
    }
}
